import React from 'react';
import { ArrowRight, CheckCircle } from 'lucide-react';
const PURCHASE_URL = 'https://digitalespro.com/cart/47867900788950:1';
export function HeroSection() {
  return <section className="bg-white py-12 md:py-20 px-4 overflow-hidden" data-id="element-68">
      <div className="max-w-4xl mx-auto text-center" data-id="element-69">
        <p className="text-gray-600 font-semibold mb-4 uppercase tracking-wider" data-id="element-70">
          📚 Para docentes de primaria
        </p>

        <h1 className="text-4xl md:text-6xl font-black text-gray-900 mb-4 leading-tight font-['Oswald'] uppercase" data-id="element-71">
          El Asombroso Viaje por el{' '}
          <span className="text-[#2980b9]" data-id="element-72">Cuerpo Humano</span>
        </h1>

        <h2 className="text-xl md:text-2xl text-gray-700 font-bold mb-8 bg-yellow-100 inline-block px-4 py-2 rounded-sm transform -rotate-1" data-id="element-73">
          Pack Completo Docente – 6 Tomos + 3 Bonos
        </h2>

        <a href={PURCHASE_URL} target="_blank" rel="noopener noreferrer" className="mb-10 relative group cursor-pointer block" data-id="element-74">
          <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 to-cyan-500 rounded-lg blur opacity-25 group-hover:opacity-50 transition duration-1000 group-hover:duration-200" data-id="element-75"></div>
          <img src="https://cdn.magicpatterns.com/uploads/phmHo9rzi53ZcMVsTALML4/mockup_cuerpo_humano_sin_fondo.png" alt="Pack Completo Cuerpo Humano" className="relative mx-auto w-full max-w-2xl transform transition hover:scale-105 duration-300" data-id="element-76" />
        </a>

        <div className="max-w-2xl mx-auto space-y-6 mb-10" data-id="element-77">
          <p className="text-xl md:text-2xl text-gray-800 font-medium" data-id="element-78">
            Todo el material de Ciencias Naturales que necesitás, listo para
            usar.
          </p>
          <p className="text-lg text-gray-600" data-id="element-79">
            Clases claras, organizadas y sin pasar horas planificando. Dejá de
            empezar desde cero cada semana.
          </p>
        </div>

        <div className="inline-block bg-blue-600 text-white font-bold px-6 py-2 rounded-full mb-8 shadow-lg" data-id="element-80">
          🌟 PACK COMPLETO DOCENTE
        </div>

        <div className="flex flex-col items-center gap-4" data-id="element-81">
          <a href={PURCHASE_URL} target="_blank" rel="noopener noreferrer" className="bg-[#f39c12] hover:bg-[#e67e22] text-white text-2xl md:text-3xl font-black py-6 px-8 md:px-12 rounded shadow-[0_6px_0_#d35400] active:shadow-[0_2px_0_#d35400] active:translate-y-1 transition-all w-full md:w-auto uppercase flex items-center justify-center gap-3 animate-pulse no-underline" data-id="element-82">
            👉 Sí, quiero acceder ahora
          </a>

          <div className="flex items-center gap-2 text-gray-600 font-semibold" data-id="element-83">
            <CheckCircle className="w-5 h-5 text-green-500" data-id="element-84" />
            <span data-id="element-85">Garantía de satisfacción de 7 días</span>
          </div>
        </div>
      </div>
    </section>;
}